<div class="page-layout-container">
  <div class="row">
    <h1 class="title">All Employees</h1>
  </div>
  <div class="table-responsive">
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="search with Employee id, name,.."
        #input
      />
    </mat-form-field>
    <button mat-button (click)="activeEmp()">Download Active Employee</button>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="employeeId" sticky>
        <th mat-header-cell *matHeaderCellDef>Employee Id</th>
        <td mat-cell *matCellDef="let element">{{ element.employeeId }}</td>
      </ng-container>

      <ng-container matColumnDef="empName" sticky>
        <th mat-header-cell *matHeaderCellDef>Employee Name</th>
        <td mat-cell *matCellDef="let element" class="tab-col">
          {{ element.empName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contractId">
        <th mat-header-cell *matHeaderCellDef>Contract Type</th>
        <td mat-cell *matCellDef="let element">{{ element.contractId }}</td>
      </ng-container>

      <ng-container matColumnDef="financeStatus">
        <th mat-header-cell *matHeaderCellDef>Finance Status</th>
        <td mat-cell *matCellDef="let element">{{ element.financeStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="nishContractId">
        <th mat-header-cell *matHeaderCellDef>NISH Contract Id</th>
        <td mat-cell *matCellDef="let element">{{ element.nishContractId }}</td>
      </ng-container>

      <ng-container matColumnDef="contractStartDate">
        <th mat-header-cell *matHeaderCellDef>Contract StartDate</th>
        <td mat-cell *matCellDef="let element">
          {{ element.contractStartDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contractEndDate">
        <th mat-header-cell *matHeaderCellDef>Contract EndDate</th>
        <td mat-cell *matCellDef="let element">
          {{ element.contractEndDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contractStatus">
        <th mat-header-cell *matHeaderCellDef>Contract Status</th>
        <td mat-cell *matCellDef="let element">{{ element.contractStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="clientName">
        <th mat-header-cell *matHeaderCellDef>Client Name</th>
        <td mat-cell *matCellDef="let element">{{ element.clientName }}</td>
      </ng-container>

      <ng-container matColumnDef="subCont">
        <th mat-header-cell *matHeaderCellDef>Contract Company name</th>
        <td mat-cell *matCellDef="let element">{{ element.subCont }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-header-cell *matHeaderCellDef>Mobile</th>
        <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
      </ng-container>

      <ng-container matColumnDef="wpExpiryMonths">
        <th mat-header-cell *matHeaderCellDef>RP Expiry Status</th>
        <td mat-cell *matCellDef="let element">{{ element.wpExpiryMonths }}</td>
      </ng-container>

      <ng-container matColumnDef="rpExpiryDate">
        <th mat-header-cell *matHeaderCellDef>RP Expiry Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.rpExpiryDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="onBoardingDate">
        <th mat-header-cell *matHeaderCellDef>OnBoarding Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.onBoardingDate | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="onBoardingStatus">
        <th mat-header-cell *matHeaderCellDef>OnBoarding Status</th>
        <td mat-cell *matCellDef="let element">
          {{ element.onBoardingStatus }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dateOfBirth">
        <th mat-header-cell *matHeaderCellDef>Date Of Birth</th>
        <td mat-cell *matCellDef="let element">
          {{ element.dateOfBirth | date : "dd/MMMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="hrSpoc">
        <th mat-header-cell *matHeaderCellDef>HR Spoc</th>
        <td mat-cell *matCellDef="let element">{{ element.hrSpoc }}</td>
      </ng-container>

      <ng-container matColumnDef="designation">
        <th mat-header-cell *matHeaderCellDef>Designation</th>
        <td mat-cell *matCellDef="let element">{{ element.designation }}</td>
      </ng-container>

      <ng-container matColumnDef="skills">
        <th mat-header-cell *matHeaderCellDef>Skills</th>
        <td mat-cell *matCellDef="let element">{{ element.skills }}</td>
        <!-- <mat-header-cell *matHeaderCellDef>Skills</mat-header-cell> class="employee-table-col"
        <mat-cell *matCellDef="let element">{{element.skills}}</mat-cell>  -->
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{
          'row-bench': row.nishContractId == null || row.contractId == 'Bench',
          'row-oneMonth': row.financeStatus == 'Billable1Month',
          'row-twoMonth': row.financeStatus == 'Billable2Month'
        }"
      ></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
  <app-progress [loading$]="loading$"> </app-progress>
</div>
